import { ContentContext } from '@/data/context/content';
import { Pagination } from '@mui/material';
import { ChangeEvent, FC, useCallback, useContext, useMemo } from 'react';
import { useDeviceType } from '@/data/deviceDetection';
import { plpPaginationSX } from '@/components/content/CatalogEntryList/styles/container';
import { useHelloRetailSearch } from '@/data/Content/HelloRetailSearch';

export const HelloretailPagination: FC = () => {
	
	const {isMobile} = useDeviceType();

	const {
		pageNumber,
		setPageNumber,
		resultCount
	} = useContext(ContentContext) as ReturnType<typeof useHelloRetailSearch>;

	const pageCount = useMemo(()=>Math.ceil(resultCount/36),[resultCount]);

	const onChange = useCallback((_: ChangeEvent<unknown>, page: number) => {
			setPageNumber(page);
			document.querySelector("#overlayDialogID")?.scrollTo(0,0);
		}, [setPageNumber]);

	return pageCount && pageCount > 1 ? (
		<Pagination 
			count={pageCount} 
			shape="rounded" 
			page={pageNumber} 
			onChange={onChange} 
			siblingCount={isMobile?0:1}
			sx={plpPaginationSX}
		/>
	) : null;
};
